// Deriver bodies extracted to @heidi/agents/data (`tool-artifact-refs.ts`); this
// file stays as the app-side binder of the ports — history: git log --follow src/features/projects/harness/artifactFromTool.ts
import { IS_SLIDE_BUILDER_ENABLED } from '@/components/constants/flags';
import type { ToolUseItem } from '@heidi/agents/contracts';
import { readToolResultText } from '@heidi/agents/contracts';
import type { Artifact } from '@heidi/agents/data';
import {
  artifactFromToolUse as artifactFromToolUseWithPorts,
  type ArtifactRefPorts,
} from '@heidi/agents/data';
import { TabType } from '@heidi/session/contracts';

const SESSION_TAB_VALUES = new Set<string>(Object.values(TabType));
const ARTIFACT_REF_PORTS: ArtifactRefPorts = {
  isSlideBuilderEnabled: () => IS_SLIDE_BUILDER_ENABLED(),
  sessionTabs: { context: TabType.CONTEXT, document: TabType.DOCUMENT },
  parseSessionTab: (value) =>
    SESSION_TAB_VALUES.has(value) ? (value as TabType) : undefined,
};

export const toolResultText = readToolResultText;
export const artifactFromToolUse = (item: ToolUseItem): Artifact | undefined =>
  artifactFromToolUseWithPorts(item, ARTIFACT_REF_PORTS);
